import { IAuthAction, SIGN_IN, SIGN_OUT } from "./types";
import IUser from "../../models/IUser";

export function signin(user: IUser): IAuthAction {
  return {
    type: SIGN_IN,
    payload: {
      ready: true,
      isAuthenticated: true,
      user: user,
    },
  };
}

export function signout(): IAuthAction {
  return {
    type: SIGN_OUT,
    payload: {
      ready: true,
      isAuthenticated: false,
      user: undefined,
    },
  };
}
